class GlobalListeners {
  constructor() {
    this.selectors = {
      quickAdds: '[quick-add-qf]',
      productForms: '[action="/cart/add"]:not(.ctl-product-form [action="/cart/add"])',
      openSideCart: '.openSideCart',
      closeSideCart: '.closeSideCart',
      removeButtons: '.cart .items-wrapper .item .remove-item',
      quantitySelectorPlus: '.cart .items-wrapper .item .quantity-wrapper .plus',
      quantitySelectorMinus: '.cart .items-wrapper .item .quantity-wrapper .minus',
      cartCount: '.cart-count',
      openDesktopSideCart: '.openDesktopSideCart',
      closeDesktopSideCart: '.closeDesktopSideCart',
    }

    this.init();
  }

  init() {
    window.log("Initialising global QF listeners");
    let vm = this;
    document.body.addEventListener('click', function (e) {
      vm.productQuickAdd(e)
      vm.siteCart(e)
      vm.siteDesktopCart(e)
      vm.quantityButtons(e)
      vm.removeCartItem(e)
    })
    vm.productForm()
    vm.cartRelated()
    vm.headerSearch()
    vm.mobileMenu()
    vm.activeDesktopSideCart()
    vm.setDeskTopCartHeight()
    vm.recommendedProducts()


    let cartResize; 
    window.addEventListener('resize', () => {

      clearTimeout(cartResize);
      
      cartResize = setTimeout( () => {
        this.setDeskTopCartHeight();
        console.log('SETTING CART HEIGHT');
      }, 150 );
    });
    
  }

  recommendedProducts() {
    let toggle_cart_recommended = document.querySelectorAll('.toggle-cart-recommended');
    let recommeneded_products = document.querySelectorAll('.side-cart-recommended-slider');
    let cart_recommended_container = document.querySelectorAll('.cart-recommendations');

    toggle_cart_recommended.forEach(toggleCartRecommended => {
      toggleCartRecommended.addEventListener('click', function (e) {
        
        toggle_cart_recommended.forEach(toggle_cart_recommended => {
          if (toggle_cart_recommended.classList.contains('active')) {
            toggle_cart_recommended.classList.remove('active');
          } else {
            toggle_cart_recommended.classList.add('active');
          }
        });
        cart_recommended_container.forEach(cart_recommended_container_item => {
          if (cart_recommended_container_item.classList.contains('active')) {
            cart_recommended_container_item.classList.remove('active');
          } else {
            cart_recommended_container_item.classList.add('active');
          }
        });
        recommeneded_products.forEach(recommenededProducts => {
          if (recommenededProducts.classList.contains("active")) {
            recommenededProducts.classList.remove('active');
          } else {
            recommenededProducts.classList.add('active');
          }
        });
        
      })
    })

    if (recommeneded_products) {
      var recommeneded_swiper = new window.swiper(".side-cart-recommended-slider", {
        slidesPerView: 2,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next.prem",
          prevEl: ".swiper-button-prev.prem",
        },
        breakpoints: {
          1300: {
            slidesPerView: 3,
            spaceBetween: 10
          }
        },
        lazy: {
          enabled: true,
          checkInView: false,
          loadOnTransitionStart: true,
          loadPrevNext: true,
          loadPrevNextAmount: 1
        },
      });
    }
  }

  productQuickAdd(e) {
    // PRODUCT QUICK ADD
    const quickAdd = e.target.closest(this.selectors.quickAdds);
    let loggedin = this.guestLogin();

    if (quickAdd) {
      e.preventDefault();
      if (quickAdd.dataset.id && quickAdd.dataset.quantity && quickAdd.dataset.quantity > 0) {
        if(loggedin == true) {
          window.modalController.presentModal("modal-login");
          window.cart.add({ items: [{ "id": quickAdd.dataset.id, "quantity": quickAdd.dataset.quantity }] });
        }else {
          window.cart.add({ items: [{ "id": quickAdd.dataset.id, "quantity": quickAdd.dataset.quantity }] });
        }
      }
    }
  }

  productForm() {
    // PRODUCT FORM LISTENER
    let productForms = document.querySelectorAll(this.selectors.productForms);
    let loggedin = this.guestLogin();

    for (let i = 0; i < productForms.length; i++) {
      let productForm = productForms[i];
      productForm.addEventListener("submit", function (e) {
        e.preventDefault();
        let quantity = productForm.querySelector("input.quantity-selector").value;
        let id = productForm.querySelector("#product-id").value;
    
        if(loggedin == true) {
          window.modalController.presentModal("modal-login");
          if (quantity && id) {
            window.cart.add({ items: [{ "id": id, "quantity": quantity }] });
          }
        }else {
          if (quantity && id) {
            window.cart.add({ items: [{ "id": id, "quantity": quantity }] });
          }
        }
      });
    }
  }

  siteCart(e) {
    // SITE CART OPEN AND CLOSE
    if (window.QF.settings.sideCart) {
      const openSideCart = e.target.closest(this.selectors.openSideCart);

      

      if (openSideCart) {
        e.preventDefault();
        window.cart.openSideCart();
      }

      const closeSideCart = e.target.closest(this.selectors.closeSideCart);
      if (closeSideCart) {
        e.preventDefault();
        window.cart.closeSideCart();
      }
    }
  }

  siteDesktopCart(e) {
    // SITE CART OPEN AND CLOSE
    if (window.QF.settings.sideCart) {
      const openDesktopSideCart = e.target.closest(this.selectors.openDesktopSideCart);
      if (openDesktopSideCart) {
        e.preventDefault();
        window.cart.openDesktopSideCart();
      }

      const closeSideCart = e.target.closest(this.selectors.closeDesktopSideCart);
      if (closeSideCart) {
        e.preventDefault();
        window.cart.closeDesktopSideCart();
      }
    }
  }

  quantityButtons(e) {
    // QUANTITY PLUS CART
    const quantityPlus = e.target.closest(this.selectors.quantitySelectorPlus)
    if (quantityPlus) {
      if (quantityPlus.getAttribute("data-pending") == "true") return false;
      quantityPlus.setAttribute("data-pending", true);

      let quantity = quantityPlus.parentNode.querySelector(".quantity span");
      let current_qty = parseInt(quantity.innerHTML) + 1;
      let stock = quantity.getAttribute("data-stock");
      let variant_id = quantity.getAttribute("data-variant-id");
      let inv_policy = quantity.getAttribute("data-inventory-policy");
      if (inv_policy == "continue" || stock > 0) {
        // if in stock or continue selling when out of stock, update cart
        window.cart.add({ items: [{ "id": variant_id, "quantity": quantity }] });
      }
      // let max_per_order = parseInt(quantity.getAttribute("data-max-per-order"));
      
      // if (current_qty <= max_per_order) {
      //   if (inv_policy == "continue" || stock > 0) {
      //     window.cart.add({ items: [{ "id": variant_id, "quantity": 1 }] });
      //   }
      // } else if (current_qty == max_per_order) {
      //   quantityPlus.setAttribute("data-pending", true);
      // }
    }

    // QUANTITY MINUS CART
    const quantityMinus = e.target.closest(this.selectors.quantitySelectorMinus)
    if (quantityMinus) {
      if (quantityMinus.getAttribute("data-pending") == "true") return false;
      quantityMinus.setAttribute("data-pending", true);

      let quantity = quantityMinus.parentNode.querySelector(".quantity span");
      let current = parseInt(quantity.innerHTML);
      let variant_id = quantity.getAttribute("data-variant-id");

      if (current > 0) {
        let updated = current - 1;
        window.cart.update({ updates: { [variant_id]: updated } });
      }
    }
  }

  removeCartItem(e) {
    // REMOVE ITEM CART
    const removeButtons = e.target.closest(this.selectors.removeButtons)
    if (removeButtons) {
      let variant_id = removeButtons.getAttribute("data-variant-id");
      window.cart.remove(variant_id)
      const item_count_el = document.querySelector('.desktop-side-cart .items-count');
      let cart_count_els = document.querySelectorAll('.cart-counter');
      const cart_count = window.cart.items;
      if (cart_count == undefined) {
        item_count_el.innerHTML = '';
         cart_count_els.forEach(cart_count_el => {
          cart_count_el.style.visibility ="hidden";
        })
      } else if (window.cart.items.length == 1) {
        item_count_el.innerHTML = '(1 item)';
        cart_count_els.forEach(cart_count_el => {
          cart_count_el.style.visibility ="visible";
          cart_count_el.innerHTML = `${window.cart.items.length}`;
        })
      } else {
        item_count_el.innerHTML = `(${window.cart.items.length} items)`;
        cart_count_els.forEach(cart_count_el => {
          cart_count_el.style.visibility ="visible";
          cart_count_el.innerHTML = `${window.cart.items.length}`;
        })
      }
    }
  }

  cartRelated() {
    // update side cart/cart after change
    let renderCarts = () => {
      if (window.template == "cart") {
        window.cart.reRenderCart();
      } else {
        if (window.QF.settings.ajax_open_side_cart) {
          /*
          if (window.innerWidth < 991.98) {
            const mobileSideCartOpened = sessionStorage.getItem('mobileSideCartOpened')
            if (mobileSideCartOpened !== 'true') {
              window.cart.openSideCart();
              sessionStorage.setItem('mobileSideCartOpened', 'true')
            } else {
              window.cart.reRenderSideCart();
            }
          } else {
          }
          */
          window.cart.reRenderDesktopSideCart();
        } else if (window.QF.settings.ajax_toast) {
          window.cart.reRenderSideCart();
        }
      }
    };
    window.addEventListener("cart_changed", renderCarts);
    window.addEventListener("item_removed", renderCarts);

    // CART COUNT
    window.addEventListener("cart_changed", (e) => {
      if (e.detail.cart) {
        let cartCount = document.querySelectorAll(".cart-count");
        cartCount.forEach((count) => {
          count.innerHTML = e.detail.cart.item_count;
        })
      }
    })
  }

  // HEADER SEARCH
  headerSearch(e) {
    const search = document.querySelector('.mega-menu .mega-menu-controls .header-search-bar-wrapper');
    const searchTrigger = document.querySelector('.mega-menu .mega-menu-controls [data-open-search]');
    const searchInput = document.querySelector('.mega-menu .mega-menu-controls .header-search-bar-wrapper .search-bar-qf input');

    // Check Search exists
    if (search) {
      // Open / Close Search
      window.addEventListener('click', function (e) {
        let target = e.target;

        if (target.hasAttribute('data-open-search')) {
          if (target.classList.contains('active')) {
            // Return if active
            return;
          } else {
            // Open if not active
            searchTrigger.classList.add('active');
            search.classList.add('active');
            searchInput.focus();
          }
        } else if (target.classList.contains('header-search') || target.getAttribute('id') == 'submit_search') {
          // Do nothing if search is clicked
          return;
        } else {
          // Close if clicked off
          searchTrigger.classList.remove('active');
          search.classList.remove('active');
        }
      });

      // Close search with Escape Key
      window.addEventListener('keydown', function (e) {
        let key = e.key;

        if (key == 'Escape') {
          if (window.activeElement.classList.contains('header-search')) {
            searchTrigger.classList.remove('active');
            search.classList.remove('active');
          } else {
            return;
          }
        }
      });
    }

  }

  // MOBILE MENU
  mobileMenu(e) {
    const menu = document.querySelector('.mobile-menu-outer-wrapper');
    const menuTrigger = document.querySelector('#open-mobile-menu');
    const closeMenu = document.querySelector('.closeMenu');

    if (menuTrigger) {
      menuTrigger.addEventListener('click', function () {
        if (menuTrigger.classList.contains('active')) {
          menu.classList.remove('active');
          menuTrigger.classList.remove('active');
        } else {
          menu.classList.add('active');
          menuTrigger.classList.add('active');
        }
      });
    }

    if (closeMenu) {
      closeMenu.addEventListener('click', () => {
        menu.classList.remove('active');
        menuTrigger.classList.remove('active');
      })
    }

    menu.addEventListener('click', function (e) {
      if (e.target.classList.contains('mobile-menu-outer-wrapper')) {
        menu.classList.remove('active');
        menuTrigger.classList.remove('active');
      }
    })

  }

  activeDesktopSideCart() {
    document.addEventListener('DOMContentLoaded', function() {
    const vw = window.innerWidth;
    let desktopSideCartStatus = window.sessionStorage.getItem("desktopSideCart");
    if ( vw > 991.98 )
    if (desktopSideCartStatus == "active") {
      window.cart.openDesktopSideCart();
    }
  });
  }

  setDeskTopCartHeight() {
      let header = document.querySelector('.mega-menu-outer-shopify-wrapper');
      let announcement_bar = document.querySelector('.announcement-bar');

      let vw = window.innerWidth;
      let header_height = header.offsetHeight;
      let announcement_bar_height = announcement_bar.offsetHeight;


      let side_cart = document.querySelector('#shopify-section-ve-desktop-side-cart');
      if (side_cart && vw > 992 ) {
        side_cart.style.height = 'calc(100vh - ' + (header_height + announcement_bar_height) + 'px)';
        side_cart.style.top = header_height + announcement_bar_height + 'px';
        
        addEventListener("scroll", () => {
          const scrollvw = window.innerWidth;
            
          if ( scrollvw > 992 ) {
            
            if (window.scrollY > announcement_bar_height) {
              side_cart.style.height = 'calc(100vh - ' + header_height + 'px)';
              side_cart.style.top = header_height + 'px';
            } else {
              side_cart.style.height = 'calc(100vh - ' + (header_height + announcement_bar_height) + 'px)';
              side_cart.style.top = header_height + announcement_bar_height + 'px';
            }

          }
        });
      } else {
        side_cart.style.height = '100vh';
        side_cart.style.top = '0';

      }
  }
  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

 guestLogin(){
    let login = this.getCookie("customer")
    let guest;

    switch(login) {
      case  '':
        guest = true;
        return guest;
        break;
      case 'guest':
        guest = false;
        return guest;
        break;
      case 'loggedin':
        guest = false;
        return guest;
    }
  }
}

window.GlobalListeners = GlobalListeners;